import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomOhgarBannerAndProductsComponent} from './custom-ohgar-banner-and-products.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {CustomProductCarouselModule} from '../../../../spartacus/custom/cms-components/product/carousel/custom-product-carousel/custom-product-carousel.module';
import {CustomOhgarTextStaticBannerModule} from '../custom-ohgar-text-static-banner/custom-ohgar-text-static-banner.module';
import {CustomCarouselModule} from '../../../../spartacus/custom/shared/components/custom-carousel/custom-carousel.module';
import {CustomAddToCartModule} from '../../../../spartacus/custom/cms-components/cart/custom-add-to-cart/custom-add-to-cart.module';
import {CustomProductItemModule} from "../custom-product-item/custom-product-item.module";

@NgModule({
  declarations: [CustomOhgarBannerAndProductsComponent],
  exports: [CustomOhgarBannerAndProductsComponent],
  imports: [
    CommonModule,
    CommonModule,
    I18nModule,
    MediaModule,
    CustomProductCarouselModule,
    RouterModule, UrlModule,
    CustomCarouselModule,
    CustomAddToCartModule,
    CustomProductItemModule,
    CustomOhgarTextStaticBannerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OhgarBannerAndProductsComponent: {
          component: CustomOhgarBannerAndProductsComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomOhgarBannerAndProductsModule { }
